import { queriesPersons } from "@query";
import { Stakeholder } from "@wingspanhq/wingspan-api-sdk";

export const useStakeholderPerson = (stakeholder: Stakeholder) =>
  queriesPersons.getPerson.useQuery(
    { personId: stakeholder.memberId as string },
    { enabled: !!stakeholder.memberId }
  );
